import { resolveTemplateMenuItems } from "./logic";
import {
  MenuItemTypeEnum,
  TemplateMenuConfigItem
} from "./types/TemplateMenuConfig.types";

export function getMenuItemAlias(name: string) {
  return `menu_${ name.toLowerCase() }_title`
}

export function findRouteByNameAndGetParentGuids(data: TemplateMenuConfigItem, routeName: string) {
  function find(item: TemplateMenuConfigItem, parentGuids: Array<string> = []): Array<string> | null {
    if (item.type === MenuItemTypeEnum.Route && item.route.name === routeName) {
      return [ ...parentGuids ];
    }

    if (item.type === MenuItemTypeEnum.Dropdown && Array.isArray(item.children)) {
      const children = resolveTemplateMenuItems(item.children)

      for (const child of children) {
        const result = find(child, [ ...parentGuids, item.guid ]);

        if (result) {
          return result;
        }
      }
    }

    return null;
  }

  return find(data);
}
